<template>
  <div class="remove-item">
    <div class="modal-backdrop"></div>
    <div class="modal task fancy-scroll" @scroll.passive="showScrollbar">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">
        Element aus einer Datenbank entfernen
      </div>
      <div class="content">
        <div class="header">
          <div class="row">
            <div class="filename-wrapper col-4">
              <input
                type="text"
                v-model="task.props.elementName"
                class="props-input"
                ref="report-name"
                placeholder="Definieren Sie den Namen für das Resultat"
                :disabled="!isUserHasAccess"
                :class="{ 'is-duplicate': isNameDuplicate(), error: shakeName }"
              />
            </div>
          </div>
        </div>
        <div class="database-drop-down">
          <div class="tab">
            <SelectDatabase
              :selectedDatabaseCaption="selectedDatabaseCaption"
              :selectedDatabaseName="selectedDatabaseName"
              :userTables="userTables"
              componentName="remove-item"
              @onDatabaseSelect="onDatabaseSelect"
            />
            <div v-if="selectedDatabaseName">
              <h3>Item Id</h3>
              <div class="input-attributes">
                <input type="text" v-model="userInputId" />
                <div
                  v-if="Object.keys(getDropdownItems).length"
                  class="custom-dropdown-id"
                >
                  <generalDropdown>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="item in getDropdownItems"
                        :key="item.name"
                        @click="onOptionSelect(item.name)"
                      >
                        {{ item.name }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>
              </div>
              <button
                class="btn"
                @click="removeItem()"
                :disabled="apiLoader || !userInputId"
              >
                <span v-if="!apiLoader">Entfernen</span>
                <div class="custom-table-progress-icon" v-if="apiLoader"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store';
import { getUserDatabases } from '../../services/userTable';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters, mapActions } from 'vuex';
import {
  isValidTaskName,
  debouncer,
  getInputPlaceholderList,
  getApiEndpointVersion,
  LATEST_FLOW_RUNNER_VERSION,
} from '@/utils/helpers';
import { getDefaultTaskName } from '@/utils/helpers/WorkFlowHelpers.js';
import SelectDatabase from '../../components/SelectDatabase.vue';
import { deleteDatabaseItem } from '../../services/axios/data.api';

export default {
  name: 'RemoveItem',
  data() {
    return {
      userInputId: '',
      userTables: [],
      apiLoader: false,
      elementName: '',
      selectedDatabaseName: null,
      selectedDatabaseCaption: null,
      shakeName: false,
    };
  },
  props: {
    task: Object,
    isUserHasAccess: { type: Boolean, default: true },
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  methods: {
    ...mapActions(['setDatabaseSchema']),
    close: async function () {
      if (
        this.isNameDuplicate() ||
        !this.task.props.elementName ||
        this.task.props.elementName === null ||
        this.task.props.elementName.trim() === '' ||
        !isValidTaskName(this.task.props.elementName)
      ) {
        this.shakeName = true;
        setTimeout(() => {
          this.shakeName = false;
        }, 500);
        return;
      }

      let outputResponse = {
        label: this.task.props.elementName,
        name: this.task.props.elementName,
        type: 'RemoveItem',
        value: null,
      };

      let outputObjectIndex = [...this.task.output].findIndex(
        (ele) =>
          ele.caption === this.elementName && ele.label === this.elementName
      );
      if (outputObjectIndex > -1) {
        this.task.output[outputObjectIndex] = outputResponse;
      } else {
        this.$set(this.task, 'output', this.task.input.concat(outputResponse));
      }
      this.task.props.database = this.selectedDatabaseName;
      this.task.props.userInputId = this.userInputId;
      this.$emit('close');
    },
    async onDatabaseSelect(database) {
      const selectedDatabase = this.userTables.find(
        (userTable) => userTable.name.trim() === database.name.trim()
      );
      if (!selectedDatabase) return;
      try {
        this.userInputId = '';
        this.selectedDatabaseName = selectedDatabase.name;
        this.selectedDatabaseCaption = selectedDatabase.caption;
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    async removeItem() {
      try {
        this.apiLoader = true;
        const id = this.getPayloadId;
        if (id === undefined) {
          throw { data: { message: 'Not found' } };
        }
        await deleteDatabaseItem(this.selectedDatabaseName, id);
        this.$emit(
          'showToaster',
          'Element erfolgreich aus der Datenbank entfernt.',
          'Erfolgreich',
          'success'
        );
      } catch (error) {
        this.$emit(
          'showToaster',
          'Es wurde kein Eintrag mit der angegebenen ID gefunden. Bitte überprüfen Sie die ID.',
          'Fehler !',
          'danger'
        );
      } finally {
        this.apiLoader = false;
      }
    },

    isNameDuplicate() {
      const htmlFilenames = this.getFileNamesFromProps(this.task.id);
      return htmlFilenames.includes(this.task.props.elementName);
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onOptionSelect(itemName) {
      this.userInputId = `{${itemName}}`;
    },
  },
  computed: {
    ...mapGetters({ databaseList: 'getDatabaseList' }),
    user() {
      return store.state.user;
    },
    getDropdownItems() {
      const apiVersion =
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION;
      const filterTaskInputs = this.task.input.filter(
        (item) =>
          !['dataframe', 'JSON'].includes(item.type) &&
          item.name !== 'codelosSettings'
      );
      return (
        getInputPlaceholderList(filterTaskInputs, apiVersion, [], true) || []
      );
    },
    getPayloadId() {
      try {
        if (
          this.userInputId !== null &&
          this.userInputId[0] === '{' &&
          this.userInputId[this.userInputId.length - 1] === '}'
        ) {
          const findName = this.getDropdownItems.find(
            (item) => item.name === this.userInputId.slice(1, -1)
          );
          if (findName?.name === 'custom' || findName?.name === 'modal') {
            return findName?.value?.id;
          }
          return findName?.value;
        }
        return this.userInputId;
      } catch (error) {
        console.log(error, 'error');
        return null;
      }
    },
  },
  async created() {
    try {
      let customTables;
      if (this.databaseList.length) {
        customTables = this.databaseList;
      } else {
        customTables = await getUserDatabases();
      }
      this.userTables = customTables.filter(
        (database) =>
          database.type === 'custom' &&
          !['read'].includes(database.access_level)
      );
      if (this.task.props.database) {
        await this.onDatabaseSelect({ name: this.task.props.database });
      }
      this.userInputId = this.task.props.userInputId;
      if (!this.task?.props?.elementName) {
        const existingTaskNames = this.getFileNamesFromProps(this.task.id);
        this.task.props.elementName = getDefaultTaskName(
          existingTaskNames,
          'RemoveItem_Antwort'
        );
      }
      this.elementName = this.task.props.elementName;
    } catch (error) {
      console.log('error :>> ', error);
    }
  },
  components: {
    GeneralDropdown,
    SelectDatabase,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.remove-item {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-item .input-attributes {
  display: flex;
  align-items: center;
}
.remove-item .input-attributes input {
  width: 100%;
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: 48px;
}

.remove-item .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: calc(100% - 36px - 17px);
  margin-top: 17px;
}
.remove-item .content .header {
  margin: 0 0 0 0;
}
.remove-item h1 {
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

.remove-item h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
  margin-top: 10px;
}

.remove-item .tab {
  text-align: left;
  width: 100%;
  height: 100%;
}

.remove-item select {
  width: 70%;
}

.remove-item button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

.remove-item button.default {
  color: #464d5d;
  background: #fff;
}
.remove-item .pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 7px;
}

.remove-item a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

.remove-item a {
  background-color: transparent;
}

.remove-item p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.remove-item .database-drop-down {
  display: flex;
  height: calc(100% - 38px - 36px);
  margin-top: 36px;
}

.remove-item .modal .database-modal {
  position: absolute;
  right: 10px;
  top: 10px;
}

.remove-item .modal .database-modal .btn-close {
  margin-left: auto;
}

.remove-item .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px !important;
}
.remove-item .btn:hover {
  border-color: #dee3e9 !important;
}
.remove-item .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #555555;
  border-color: #555555 transparent #555555 transparent;
  margin-left: 10px;
  animation: progress-icon-animation 1.2s linear infinite;
}

.remove-item .header .filename-wrapper {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #464d5d;
}

.remove-item .header .props-input {
  font-size: 15px !important;
  line-height: 28px !important;
  cursor: text !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  color: #000 !important;
  border: 1px solid #e2e2e2 !important;
  border-radius: 6px !important;
  padding: 12px 12px !important;
  height: 38px !important;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.remove-item .header .props-input:focus {
  outline: none;
}
.remove-item .header .is-duplicate {
  background: #ff050578;
}
.remove-item .header .error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}
.remove-item .input-attributes ::v-deep .customDropdown {
  box-shadow: none;
}
@keyframes shake {
  0% {
    margin-left: 2rem;
  }
  25% {
    margin-left: 2.2rem;
  }
  75% {
    margin-left: 1.8rem;
  }
  100% {
    margin-left: 2rem;
  }
}

.remove-item .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.remove-item .jv-container.jv-light {
  height: calc(100% - 206px);
}

.remove-item .jv-container ::v-deep .jv-code {
  height: 100% !important;
  overflow-y: auto !important;
}
</style>
